<mat-chip-grid #chipList>

  @for (item of selected; track item) {
    <mat-chip-row [removable]="removable" (removed)="remove(item)">
      {{item.name}}
      @if (removable) {
        <button matChipRemove> <mat-icon>cancel</mat-icon> </button>
      }
    </mat-chip-row>
  }

  <input #inputTrigger matInput [formControl]="inputControl" [matAutocomplete]="autoComplete"
    [matChipInputFor]="chipList" [placeholder]="inputPlaceholder" (focus)="isInputFocused = true"
    (blur)="isInputFocused = false">

    @if(hasArrowDown) {
      <mat-icon>arrow_drop_down</mat-icon>
    }
  </mat-chip-grid>

  <mat-autocomplete #autoComplete="matAutocomplete" (optionSelected)="toggleSelection($event.option.value)">
    @for ( item of filteredItems; track  item) {
      <mat-option [value]="item" [disabled]="disabledItems.includes(item.id)">
        <mat-checkbox [checked]="isItemSelected(item)"> {{ item.name }} </mat-checkbox>
      </mat-option>
    }
  </mat-autocomplete>